/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Представление всплывающего окна "Соглашение на обработку персональных данных"
   */
  app.AgreementPopupView = app.View.extend({
    /**
     * Дополнительные опции.
     */
    additionalOptions: ['opener'],

    /** @inheritDoc */
    run: function () {
      this.popup = new als.Popup(this.$el, $(this.opener));
      if (this.opener) {
        $(this.opener).click(this.preventRedirection);
      }
    },

    /**
     * Убирает редирект.
     *
     * @param {Event} e
     */
    preventRedirection: function (e) {
      e.stopImmediatePropagation();
    },
  });
})(jQuery);

}.call(window));